import React from "react";

export const game_info = (
    <svg
        id="layer1"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
    >
        <path
            id="path1538"
            d="M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm-.084,3.58h0a1.391,1.391,0,1,1-1.391,1.391A1.391,1.391,0,0,1,11.92,3.58ZM9.078,8.875h4.066V18.4h1.777V20.42H9.078V18.4h1.8V10.891h-1.8Z"
        />
    </svg>
);
